import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as DocCreateNewVersionIconSvg } from '../../assets/document-new-version-icon.svg';
import Icon from '@ant-design/icons';

export const CreateNewVersionIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocCreateNewVersionIconSvg} {...props} />;
};
